import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getReplies(appId, params, commentId) {
        const res = await http.get(buildUrlFromLocation(`/app/${appId}/comments-list?${params}&order=asc&parent=${commentId}`));
        return res.data;
    },
    async postReply(appId, subComment) {
        return await http.post(buildUrlFromLocation(`/app/${appId}/comment`), subComment);
    }
};



// WEBPACK FOOTER //
// ./src/services/comment.js